import { t } from '../ui/lang';
import { fetchClickerApps } from '../clicker/clicker-apps-shared';
import { mountOperationsRegistry } from '../clicker/clicker-operations-shared';
// Remembered rows-per-page for this table (the per-device popup keeps its own).
const PAGE_SIZE_KEY = 'mf.teamOpsPageSize';
/** Farms for the Farm filter — whatever GET /api/farms returns for this user, which is
 *  scoped exactly like the registry endpoint (own team for admins and below, every team
 *  for a superadmin), so every option can actually return rows. */
async function loadFarms() {
    const res = await fetch('/api/farms');
    if (!res.ok)
        throw new Error(t('dashboards.failed_to_load_farms'));
    const farms = await res.json();
    return farms.map((f) => ({ id: f.id, name: f.name, teamId: f.team_id ?? null }));
}
/** Teams for the Team filter — only a superadmin is offered it (UI_ACCESS 'ops.team'), and
 *  GET /api/teams returns every team for them. */
async function loadTeams() {
    const res = await fetch('/api/teams');
    if (!res.ok)
        throw new Error('failed to load teams');
    const teams = await res.json();
    return teams.map((tm) => ({ id: tm.id, name: tm.name }));
}
/**
 * "Operations" tab of the Dashboards page — the TEAM-WIDE operations registry: every
 * deposit/payout every device the viewer can reach finalized, newest first, in one table.
 * That is the viewer's own team for admins and below; a superadmin sees every team.
 *
 * The per-device popup answers "what did this phone do"; this answers "what did the team
 * do", which is the view you need when an operation is quoted in a ticket and nobody
 * knows which phone ran it — hence the Operation ID search and the Device column
 * ("farm/name (udid)"), plus the operator who had the clicker running at the time.
 *
 * It mounts the SAME registry component as the popup (clicker-operations-shared.ts), so
 * the filters and columns cannot drift between the two surfaces.
 */
export function renderOperationsTab(panel) {
    panel.innerHTML = `<div class="team-ops-registry"></div>`;
    mountOperationsRegistry(panel.querySelector('.team-ops-registry'), {
        scope: 'team',
        pageSizeKey: PAGE_SIZE_KEY,
        endpoint: (params) => `/api/operations?${params.toString()}`,
        // The whole catalog, not one farm's availability list: the table spans every farm.
        loadApps: () => fetchClickerApps(),
        loadFarms,
        loadTeams,
    });
}
